<div id="main-wrapper">

    <app-header></app-header>

    <app-sidebar></app-sidebar>

    <div class="page-wrapper">
        <div class="container-fluid">

            <!-- <app-breadcrumbs></app-breadcrumbs>-->

        </div>
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <!-- <app-breadcrumbs></app-breadcrumbs> -->
                    <router-outlet></router-outlet>

                </div>
            </div>
        </div>
        <!--  <router-outlet></router-outlet> -->

    </div>
    <br>
    <!-- <footer class="footer">
        <p style="text-align: center; ">Colegio de Estudios Científicos y Tecnológicos del Estado de Veracruz • Derechos reservados • ©️ {{anio}} -</p>

    </footer> -->

</div>